import { render, staticRenderFns } from "./MensagemList.vue?vue&type=template&id=e0b72b30&scoped=true&"
import script from "./MensagemList.vue?vue&type=script&lang=js&"
export * from "./MensagemList.vue?vue&type=script&lang=js&"
import style0 from "./MensagemList.vue?vue&type=style&index=0&id=e0b72b30&lang=scss&scoped=true&"
import style1 from "./MensagemList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b72b30",
  null
  
)

export default component.exports